import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import querystring from "query-string";

export const useQueryStringParams = (): querystring.ParsedQuery<string> => {
  const { search } = useLocation();

  return useMemo(() => querystring.parse(search), [search]);
};
